import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AppComponent } from './app.component';
import { HeroSectionComponent } from './pages/home-page/components/hero-section/hero-section.component';
import { FooterComponent } from './root-components/footer/footer.component';
import { AppButtonComponent } from './root-components/app-button/app-button.component';
import { AppTextareaComponent } from './root-components/app-textarea/app-textarea.component';
import { CardComponent } from './root-components/card/card.component';
import { HomeComponent } from './pages/home-page/home.component';
import { AboutComponent } from './pages/about-page/about.component';
import { ServicesComponent } from './pages/services-page/services.component';
import { ContactComponent } from './pages/contact-page/contact.component';
import { NotfoundPageComponent } from './pages/notfound-page/notfound-page.component';
import { ServiceCardComponent } from './pages/services-page/components/service-card/service-card.component';
import { ProcessFollowComponent } from './pages/services-page/components/process-follow/process-follow.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ContactFormComponent } from './pages/contact-page/components/contact-form/contact-form.component';
import { DetailsPageComponent } from './pages/details-page/details-page.component';
import { firebaseConfig } from '../../firebase-config';
import { initializeApp } from 'firebase/app';
import { PricingComponent } from './pages/pricing-page/pricing.component';
import { PricingCardComponent } from './pages/pricing-page/components/pricing-card/pricing-card.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { ArticaleServiceComponent } from './pages/details-page/components/articale-service/articale-service.component';
import { MultiImagesServiceComponent } from './pages/details-page/components/multi-images-service/multi-images-service.component';
import { VideoServiceComponent } from './pages/details-page/components/video-service/video-service.component';
import { HomeTertiarySectionComponent } from './pages/home-page/components/home-tertiary-section/home-tertiary-section.component';
import { HomeQuaternarySectionComponent } from './pages/home-page/components/home-quaternary-section/home-quaternary-section.component';
import { GridCardsWithoutFrameComponent } from './pages/home-page/components/grid-cards-without-frame/grid-cards-without-frame.component';
import { GridCardsWithFrameComponent } from './pages/home-page/components/grid-cards-with-frame/grid-cards-with-frame.component';
import { ImageServiceComponent } from './pages/details-page/components/image-service/image-service.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { OurClientComponent } from './pages/home-page/components/our-client/our-client.component';
import { CarouselModule } from 'primeng/carousel';
import { CourseDetailsComponent } from './pages/details-page/components/course-details/course-details.component';
import { AccordionModule } from 'primeng/accordion';
import { GridServiceCardsComponent } from './pages/services-page/components/grid-service-cards/grid-service-cards.component';
import { CircleTextWithImageComponent } from './pages/about-page/components/circle-text-with-image/circle-text-with-image.component';
import { ImageWithCircleTextComponent } from './pages/about-page/components/image-with-circle-text/image-with-circle-text.component';
import { TextWithFourImagesComponent } from './pages/about-page/components/text-with-four-images/text-with-four-images.component';
import { FourImageWithTextComponent } from './pages/about-page/components/four-image-with-text/four-image-with-text.component';
import { TextWithOneImageComponent } from './pages/about-page/components/text-with-one-image/text-with-one-image.component';
import { TextWithCoverImageComponent } from './pages/about-page/components/text-with-cover-image/text-with-cover-image.component';
import { OurProjectsComponent } from './pages/home-page/components/our-projects/our-projects.component';
import { environment } from '../environments/environment';
import { VersionComponentComponent } from './root-components/version-component/version-component.component';
import { WorkCounterComponent } from './pages/home-page/components/work-counter/work-counter.component';
import { ScullyLibModule } from '@scullyio/ng-lib';
import { ButtonModule } from 'primeng/button';

import { GalleriaModule } from 'primeng/galleria';
import { MultiTextWithImageComponent } from './pages/home-page/components/multi-text-with-image/multi-text-with-image.component';
import { TextWithImageComponent } from './pages/home-page/components/text-with-image/text-with-image.component';
import { ImageWithTextComponent } from './pages/home-page/components/image-with-text/image-with-text.component';
import { CourseComponent } from './pages/course/course.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { UserDataComponent } from './pages/profile-page/components/user-data/user-data.component';
import { MyCoursesComponent } from './pages/profile-page/components/my-courses/my-courses.component';
import { MyPaymentsComponent } from './pages/profile-page/components/my-payments/my-payments.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/otp-code/otp-code.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { HeroWithOneImageComponent } from './pages/home-page/components/hero-with-one-image/hero-with-one-image.component';
import { EDetailsPageComponent } from './pages/e-details-page/e-details-page.component';
import { RatingModule } from 'primeng/rating';
import { OneImageWithTextComponent } from './pages/about-page/components/one-image-with-text/one-image-with-text.component';
import { MultiImagesWithTextComponent } from './pages/home-page/components/multi-images-with-text/multi-images-with-text.component';
import { GalleryComponent } from './pages/home-page/components/gallery/gallery.component';
import { ArticaleComponent } from './pages/about-page/components/articale/articale.component';
import { HeroImageTextComponent } from './pages/home-page/components/hero-image-text/hero-image-text.component';
import { HeaderComponent } from './root-components/header/header.component';
import { TokenInterceptor } from './shared/interceptor/token-interceptor/token.interceptor';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AccordionComponent } from './pages/details-page/components/accordion/accordion.component';
import { HeroCarouselComponent } from './pages/home-page/components/hero-carousel/hero-carousel.component';
import { ProductCardComponent } from './pages/products-page/components/product-card/product-card.component';
import { TabsComponent } from './pages/products-page/components/tabs/tabs.component';
import { ProductsPageComponent } from './pages/products-page/products-page.component';
import { TextWithImagesBelowComponentComponent } from './pages/about-page/components/text-with-images-below-component/text-with-images-below-component.component';
import { DashboardEditorComponent } from './dashboard/dashboard.component';
import { DashboardLoginComponent } from './dashboard/components/dashboard-login/dashboard-login.component';
import { TeacherPageComponent } from './pages/teacher-page/teacher-page.component';
import { HeroTextWithImgComponent } from './pages/teacher-page/components/hero-text-with-img/hero-text-with-img.component';
import { WebsiteCardComponent } from './pages/teacher-page/components/our-works/components/website-card/website-card.component';
import { WebsitePreviewComponent } from './pages/teacher-page/components/our-works/components/website-preview/website-preview.component';
import { OurWorksComponent } from './pages/teacher-page/components/our-works/our-works.component';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { TitleWithButtonComponent } from './pages/info-page/components/title-with-button/title-with-button.component';
import { CustomWebsiteComponent } from './pages/custom-website/custom-website.component';
import { WhatsappButtonComponent } from './shared/components/whatsapp-button/whatsapp-button.component';
import { DoctorPageComponent } from './pages/doctor-page/doctor-page.component';
import { OnlineStorePageComponent } from './pages/online-store-page/online-store-page.component';
import { RestaurantPageComponent } from './pages/restaurant-page/restaurant-page.component';
import { BorderedIconCardComponent } from './root-components/bordered-icon-card/bordered-icon-card.component';
import { VerticalStepsComponent } from './root-components/vertical-steps/vertical-steps.component';

const app = initializeApp(firebaseConfig);
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    './assets/' + environment.projectName + '/i18n/',
    '.json'
  );
}

@NgModule({
  declarations: [
    AppComponent,
    HeroSectionComponent,
    TitleWithButtonComponent,
    FooterComponent,
    AppButtonComponent,
    InfoPageComponent,
    CustomWebsiteComponent,    
    WebsitePreviewComponent,
    OurWorksComponent,
    AppTextareaComponent,
    CardComponent,
    WebsiteCardComponent,
    HeaderComponent,
    HomeComponent,
    TeacherPageComponent,
    AboutComponent,
    ServicesComponent,
    ContactComponent,
    NotfoundPageComponent,
    CourseComponent,
    ServiceCardComponent,
    ProcessFollowComponent,
    ContactFormComponent,
    DetailsPageComponent,
    PricingComponent,
    DashboardEditorComponent,
    PricingCardComponent,
    PolicyPageComponent,
    ArticaleServiceComponent,
    MultiImagesServiceComponent,
    VideoServiceComponent,
    HomeTertiarySectionComponent,
    HomeQuaternarySectionComponent,
    GridCardsWithoutFrameComponent,
    GridCardsWithFrameComponent,
    ImageServiceComponent,
    DashboardComponent,
    OurClientComponent,
    CourseDetailsComponent,
    GridServiceCardsComponent,
    CircleTextWithImageComponent,
    ImageWithCircleTextComponent,
    TextWithFourImagesComponent,
    FourImageWithTextComponent,
    TextWithOneImageComponent,
    TextWithCoverImageComponent,
    OurProjectsComponent,
    VersionComponentComponent,
    WorkCounterComponent,
    TextWithImageComponent,
    ImageWithTextComponent,
    ProfilePageComponent,
    UserDataComponent,
    MyCoursesComponent,
    MyPaymentsComponent,
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    OtpCodeComponent,
    ForgetPasswordComponent,
    HeroWithOneImageComponent,
    MultiTextWithImageComponent,
    EDetailsPageComponent,
    MultiTextWithImageComponent,
    OneImageWithTextComponent,
    MultiImagesWithTextComponent,
    GalleryComponent,
    ArticaleComponent,
    HeroImageTextComponent,
    RefundPolicyPageComponent,
    PaymentComponent,
    HeroCarouselComponent,
    ProductsPageComponent,
    TabsComponent,
    ProductCardComponent,
    HeroTextWithImgComponent,
    AccordionComponent,
    TextWithImagesBelowComponentComponent,
    DashboardLoginComponent,
    WhatsappButtonComponent,
    DoctorPageComponent,
    OnlineStorePageComponent,
    RestaurantPageComponent,
    BorderedIconCardComponent,
    VerticalStepsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    CarouselModule,
    AccordionModule,
    ButtonModule,
    RatingModule,
    ScullyLibModule,
    GalleriaModule,
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
